/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * FINRA Market Data API
 * Market data aggregation backend for FINRA data sources
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetIndexChartParams,
  HTTPValidationError,
  IndexChartData,
  InternalErrorResponse,
  NotFoundErrorResponse,
  UpstreamAuthenticationFailedErrorResponse,
  UpstreamBadGatewayErrorResponse,
  UpstreamUnavailableErrorResponse
} from '../fINRAMarketDataAPI.schemas.ts';

import { apiFetch } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getIndexChartResponse200 = {
  data: IndexChartData
  status: 200
}

export type getIndexChartResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}

export type getIndexChartResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getIndexChartResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getIndexChartResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getIndexChartResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getIndexChartResponseSuccess = (getIndexChartResponse200) & {
  headers: Headers;
};
export type getIndexChartResponseError = (getIndexChartResponse404 | getIndexChartResponse422 | getIndexChartResponse500 | getIndexChartResponse502 | getIndexChartResponse503) & {
  headers: Headers;
};

export type getIndexChartResponse = (getIndexChartResponseSuccess | getIndexChartResponseError)

export const getGetIndexChartUrl = (index: string,
    params: GetIndexChartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/indices/${index}/chart?${stringifiedParams}` : `/api/v1/indices/${index}/chart`
}

/**
 * Get historical OHLCV chart data for an index.
 *
 * Args:
 *     index: The index identifier ("dow_jones", "nasdaq", or "s_p_500")
 *     morningstar: Injected MorningstarMarketDataClient instance
 *     start_date: Start of date range in DD-MM-YYYY format (e.g., "01-01-2025")
 *     end_date: End of date range in DD-MM-YYYY format (e.g., "31-12-2025")
 *
 * Returns:
 *     IndexChartData wrapping the Morningstar time-series response
 *
 * Raises:
 *     404: Index identifier not recognized
 *     500: Morningstar API error or authentication failure
 * @summary Get Index Chart
 */
export const getIndexChart = async (index: string,
    params: GetIndexChartParams, options?: RequestInit): Promise<getIndexChartResponse> => {

  return apiFetch<getIndexChartResponse>(getGetIndexChartUrl(index,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIndexChartQueryKey = (index: string,
    params?: GetIndexChartParams,) => {
    return [
    `/api/v1/indices/${index}/chart`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetIndexChartQueryOptions = <TData = Awaited<ReturnType<typeof getIndexChart>>, TError = NotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(index: string,
    params: GetIndexChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndexChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIndexChartQueryKey(index,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIndexChart>>> = ({ signal }) => getIndexChart(index,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: index !== null && index !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIndexChart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIndexChartQueryResult = NonNullable<Awaited<ReturnType<typeof getIndexChart>>>
export type GetIndexChartQueryError = NotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetIndexChart<TData = Awaited<ReturnType<typeof getIndexChart>>, TError = NotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 index: string,
    params: GetIndexChartParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndexChart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndexChart>>,
          TError,
          Awaited<ReturnType<typeof getIndexChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndexChart<TData = Awaited<ReturnType<typeof getIndexChart>>, TError = NotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 index: string,
    params: GetIndexChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndexChart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndexChart>>,
          TError,
          Awaited<ReturnType<typeof getIndexChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndexChart<TData = Awaited<ReturnType<typeof getIndexChart>>, TError = NotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 index: string,
    params: GetIndexChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndexChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Index Chart
 */

export function useGetIndexChart<TData = Awaited<ReturnType<typeof getIndexChart>>, TError = NotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 index: string,
    params: GetIndexChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndexChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIndexChartQueryOptions(index,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






